import React from 'react';
import { Link } from 'react-router-dom';
import './Footer.css';

const Footer = () => {
  return (
    <footer className="footer">
      <div className="footer-content">
        <div className="footer-center">
          <p className="footer-text">
            &copy; {new Date().getFullYear()} Fixetra. All rights reserved. 
            <Link to="/privacy" style={{ marginLeft: '10px', color: 'inherit' }}>
              Privacy Policy
            </Link>
            <Link to="/terms-of-service" style={{ marginLeft: '10px', color: 'inherit' }}>
              Terms of Service
            </Link>
            <a href="/sitemap.xml" style={{ marginLeft: '10px', color: 'inherit' }}>Sitemap</a>
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer; 